export interface ParsedQWSTicker {
  ticker: string;
  market: 'JP' | 'US';
}

/**
 * Normalizes codelist by trimming each token and dropping empty entries.
 * Example: " 4307/T, AAPL,  " -> "4307/T,AAPL"
 */
export const normalizeQWSCodelist = (codelist: string): string => {
  return codelist
    .split(',')
    .map(code => code.trim())
    .filter(Boolean)
    .join(',');
};

/**
 * Parses QWS codelist query param (comma-separated).
 * Japanese equities: 4-digit + "/T" → strip "/T".
 * North American: ticker as-is (QWS already stripped "@" and "/U").
 */
export const parseQWSCodelist = (codelist: string): ParsedQWSTicker[] => {
  return normalizeQWSCodelist(codelist)
    .split(',')
    .map(code => {
      const trimmed = code.trim();
      if (!trimmed) return null;
      if (trimmed.endsWith('/T')) {
        return { ticker: trimmed.slice(0, -2).trim(), market: 'JP' as const };
      }
      return { ticker: trimmed, market: 'US' as const };
    })
    .filter((t): t is ParsedQWSTicker => t !== null && t.ticker.length > 0);
};

/**
 * Builds CSV string for entity-resolver/v3/csv (comma-separated tickers).
 * Resolver will lowercase and dedupe.
 */
export const toResolverCSV = (parsed: ParsedQWSTicker[]): string => {
  return parsed.map(t => t.ticker).join(',');
};
